import React from 'react';
import {List, ListItem, ListItemText, Divider} from '@material-ui/core';
import {toFormattedDateTime} from 'Shared/utilities/DateFormatter';
import './EnrollmentFilesNotProcessedNotesModal.sass';
import {EnrollmentFileNotes} from 'Enrollment/models/EnrollmentFileNotes';
import Modal from 'Shared/components/Modal';

type EnrollmentFilesNotProcessedNotesModalProps = {
  onClose: () => void;
  notes: Array<EnrollmentFileNotes>;
};

const EnrollmentFilesNotProcessedNotesModal = (props: EnrollmentFilesNotProcessedNotesModalProps) => {
  const {notes, onClose} = props;
  return (
    <Modal title="Notes" open onClose={onClose} disableBackdropClick>
      <div className="notes-modal">
        {notes.length > 0 ? (
          <>
            {notes.map((note, index) => (
              <List key={index}>
                <ListItem>
                  <ListItemText
                    primary={note.noteType}
                    secondary={`${toFormattedDateTime(note.modifiedDate)} | By: ${note.modifiedBy}`}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText primary={note.noteSubType} />
                </ListItem>
                <ListItem>
                  <ListItemText primary={note.noteText} />
                </ListItem>
                {index + 1 < notes.length && <Divider />}
              </List>
            ))}
          </>
        ) : (
          <p className="notes-modal__no-notes-available-message"> No Notes available.</p>
        )}
      </div>
    </Modal>
  );
};
export default EnrollmentFilesNotProcessedNotesModal;
